<template>
  <button
    :disabled="!isActive"
    class="tw-cursor-pointer tw-p-3 tw-bg-white tw-shadow-sm
    tw-rounded-lg tw-text-[#F1583D] tw-flex tw-items-center tw-justify-between
    tw-font-medium tw-whitespace-nowrap tw-border tw-border-solid tw-border-[#DFE2E7]
    disabled:tw-bg-white disabled:tw-text-[#B3B9C6] disabled:tw-cursor-not-allowed"
    @click="openRiskQuestionnaire"
  >
    {{ buttonText }}
    <i class="fas fa-chevron-right tw-ml-2" />
  </button>
</template>

<script>
import { mapStores } from 'pinia';
import { useCheckupStore } from '@frontend/ui/stores/checkupStore';
import { useAdvisorStore } from '@frontend/ui/stores/advisorStore.js';

export default {
  name: 'RiskQuestionnaireButton',
  props: {
    isActive: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapStores(useCheckupStore, useAdvisorStore),
    buttonText() {
      return this.checkupStore?.personEntity?.risk_score ?
        'Re-Take Risk Questionnaire' :
        'Take Risk Questionnaire';
    },
    riskQuestionnaireUrl() {
      if (!this.checkupStore.personEntity) {
        return `${this.publicQuestionnaireLink}?questionnaire_type=risk&checkup_id=${this.checkupStore.portfolio_checkup_id}`;
      }
      return `${window.location.protocol}//${window.location.host}/questionnaire/questions/v2_${btoa(this.checkupStore.personEntity?.external_id)}/?questionnaire_type=risk&checkup_id=${this.checkupStore.portfolio_checkup_id}`;
    },
    slug() {
      const advisor = this.advisorStore.advisor;
      return advisor?.link_slug || advisor?.slug;
    },
    publicQuestionnaireLink() {
      return `${window.location.protocol}//${window.location.host}/questionnaire/intro/${this.slug}/`;
    },
  },
  methods: {
    async openRiskQuestionnaire() {
      window.open(this.riskQuestionnaireUrl, '_blank');
    },
  },
};
</script>
